import React from "react";
import { classNames } from "../../../helpers/classNames";

const SelectOptions = ({ className, width, ...props }) => {
  return (
    props?.open &&
    !props?.disabled && (
      <div
        ref={props?.setPopperElement}
        className={classNames(
          "!fixed bg-white rounded-lg shadow-lg z-50 my-1 min-h-fit",
          className
        )}
        style={{
          ...props.styles.popper,
          minWidth: width || props?.dropdownPosition?.width,
        }}
      >
        {props?.children}
      </div>
    )
  );
};

export default SelectOptions;
